import { render, staticRenderFns } from "./ViewPositions.vue?vue&type=template&id=6a15a3e4&scoped=true"
import script from "./ViewPositions.vue?vue&type=script&lang=js"
export * from "./ViewPositions.vue?vue&type=script&lang=js"
import style0 from "./ViewPositions.vue?vue&type=style&index=0&id=6a15a3e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a15a3e4",
  null
  
)

export default component.exports